import PracticeFrontPreviewStore from 'store/PracticeFrontPreview';

const useRefreshPreview = () => {
    const [, set] = PracticeFrontPreviewStore.useStore();

    return [set];
};

export default useRefreshPreview;
